import type { BookingStatus } from "./BookingDetailDialog";

export const STATUS_LABEL: Record<BookingStatus, string> = {
  pending: "En attente",
  confirmed: "Confirmé",
  completed: "Terminé",
  cancelled: "Annulé",
};

export const STATUS_ROW_CLASS: Record<BookingStatus, string> = {
  pending: "bg-gold/10 hover:bg-gold/15",
  confirmed: "bg-primary/10 hover:bg-primary/15",
  completed: "bg-accent/10 hover:bg-accent/15",
  cancelled: "bg-destructive/10 hover:bg-destructive/15",
};

export const STATUS_DOT_CLASS: Record<BookingStatus, string> = {
  pending: "bg-gold",
  confirmed: "bg-primary",
  completed: "bg-accent",
  cancelled: "bg-destructive",
};

export const STATUS_ORDER: BookingStatus[] = ["pending", "confirmed", "completed", "cancelled"];

export const toDayKey = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
